import {fetchApi} from "@src/workflows/vs-standard-form/helpers/form.helper";
import {getHeader} from "@src/workflows/vs-standard-form/vs-standard-form.constant";

export async function validateSentosaGolfBooking(baseUrl: string, xDataCenter: string, token: string) {
  const loginUrl: string = baseUrl + '/mepa-api/app/v1/sentosa_golf/validate';
  return fetchApi(loginUrl, getHeader(xDataCenter, {}, token, false));
}
